import './scss/main.scss';


// steamGameScreenShotUpload.js
import './js/steamGameScreenShotUpload.js';

// manualVoting
import './js/manualVoting.js';


// UserProfile.js
import './js/UserProfile.js';

// Logout.js
import './js/Logout.js';